import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";
import moment from "moment";

import { formatDate, formatDateInput } from "../../../../../../common/vue-helpers/modifiers/value-modifier";
import { IProblemsResponse, LookupService } from "../../../../../../services/lookup-service";

import EmptyTextHandler from "../../../../../../resources-vue/vue-custom-elements/EmptyTextHandler/EmptyTextHandler.vue";
import TablePrompt from "../../../../../../resources-vue/vue-custom-elements/TablePrompt/TablePrompt.vue";
import CommentInput from "../../../../../../resources-vue/vue-custom-elements/CommentInput/CommentInput.vue";
import DatePicker from "../../../../../../resources-vue/vue-custom-elements/DatePicker/DatePicker.vue";
import Problems from "../../../../../../resources-vue/vue-custom-elements/Problems/Problems.vue";
import TypeaheadInput from "../../../../../../resources-vue/vue-custom-elements/TypeaheadInput/TypeaheadInput.vue";

export default defineComponent({
    components: {
        Problems,
        EmptyTextHandler,
        TablePrompt,
        CommentInput,
        DatePicker,
        TypeaheadInput
    },
    props: {
        problem: {
            type: Object
        },
        updateProblem: {
            type: Function
        },
        deleteProblem: {
            type: Function
        },
        first: {
            type: Boolean
        },
        last: {
            type: Boolean
        },
        isAddRequested: {
            type: Boolean
        },
        id: {
            type: String
        },
        isNewTerminal: {
            type: Boolean,
            default: false
        },
        cancelSaveNewProblem: {
            type: Function
        },
        moveProblemDown: {
            type: Function
        },
        resolveProblem: {
            type: Function
        },
        moveProblemUp: {
            type: Function
        },
        saveNewProblem: {
            type: Function
        },
        index: {
            type: Number
        },
        columns: {
            type: Number,
            default: 5
        },
        application: {
            type: Number
        }
    },
    data(vm) {
        return {
            formatDate,
            formatDateInput,
            _lookupService: null,
            _isRelatedSubscription: null,
            isEditRequested: false,
            isResolveRequested: false,
            problemCache: null,
            selectedProblem: null,
            isDeleteRequested: null,
            deleteMessage: `Do you want to delete this problem?`,
            resolveDatePickerOptions: {
                endDate: moment().format("MM/DD/YYYY")
            },
            resolvedDate: ""
        };
    },
    emits: ["update:isAddRequested"],
    created() {
        this._lookupService = Container.instance.get(LookupService);
    },
    mounted() {
        this.problemCache = { ...this.problem };
    },
    methods: {
        selectedProblemChanged(newValue: any) {
            if (newValue) {
                this.problem.code = newValue.value;
                this.problem.description = newValue.name;
            }
        },

        async save() {
            this.$emit("update:isAddRequested", false);
            this.problemCache = { ...this.problem };
            this.selectedProblem = null;
            this.saveNewProblem(this.index);
        },

        openEditProblem() {
            this.problemCache = { ...this.problem };
            if (this.problem.code !== null) {
                this.selectedProblem = {
                    value: this.problem.code,
                    name: this.problem.description
                };
            }
            this.isEditRequested = true;
        },

        cancelEditProblem() {
            this.isEditRequested = false;
            this.updateProblem?.({ ...this.problemCache }, this.index);
            this.selectedProblem = null;
        },

        async saveEditProblem() {
            this.isEditRequested = false;
            this.problemCache = { ...this.problem };
            this.selectedProblem = null;
        },

        openResolveProblem() {
            this.isResolveRequested = true;
        },

        cancelResolveProblem() {
            this.problem.resolvedDate = null;
            this.isResolveRequested = false;
            this.resolvedDate = null;
        },

        async saveResolveProblem(index: any) {
            this.resolveProblem(index);
            this.problem.resolvedDate = this.resolvedDate;
            this.isResolveRequested = false;
        },

        openDeleteProblem() {
            this.isDeleteRequested = true;
        },

        deleteProb() {
            this.deleteProblem();
        },

        cancelDeleteRequest() {
            this.isDeleteRequested = false;
        },

        async getProblemsList(filter: string) {
            let data = await this._lookupService.getProblems({
                term: filter,
                application: this.application
            });
            return data.map((problem: IProblemsResponse) => ({
                name: problem.Description,
                value: problem.Code
            }));
        },

        handleDateChange(date: any, name: string) {
            if (name === "resolvedDate") {
                this.resolvedDate = date;
            }
            if (name === "startDate") {
                this.problem.onsetDate = date;
            }
        },
        handleDate(e: any) {
            const name = e.target.name;
            const value = e.target.value;
            this.handleDateChange(value, name);
        },
        handleIsPresentOnAdmission() {
            this.problem.isPresentOnAdmission = !this.problem.isPresentOnAdmission;
        }
    }
});
